import { ISimpleFilterModel } from '@ag-grid-community/core'
import { SetFilterModel } from '@ag-grid-enterprise/set-filter'
import { Filter, FilterType } from './filter'

enum BooleanSetValues {
  TRUE = 'True',
  FALSE = 'False',
}

export interface SetFilter extends Filter {
  filterType: FilterType.Set
  values: (string | null)[]
}

/**
 * Convert simple filter to set filter
 */
export function convertISimpleFilterModelToSetFilter(
  filter: ISimpleFilterModel,
): SetFilter | null {
  if (filter.filterType !== 'set') {
    console.error('Filter type should be set', filter)
    return null
  }
  const filterModel = filter as SetFilterModel

  return {
    filterType: FilterType.Set,
    values: convertTrueFalseToBooleans(filterModel.values),
  }
}

/**
 * Convert the "True" to true and "False" to false
 *
 * Returns a copy: the values belong to the grid's applied filter, which saved grid state reads back.
 */
function convertTrueFalseToBooleans(values: SetFilterModel['values']) {
  return values?.map(value => {
    if (value === BooleanSetValues.TRUE) {
      return true as unknown as string
    } else if (value === BooleanSetValues.FALSE) {
      return false as unknown as string
    }
    return value
  })
}
